import { useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useFormik } from "formik";

// @material-ui/core components
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  FormLabel,
  Grid,
  TextField,
  FormGroup,
} from "@material-ui/core";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";

export default function DialogCancelOrder({
  open,
  onClose,
  IdAtendimento,
  IdPessoaLoja,
}) {
  const [submitting, setSubmitting] = useState(false);
  const snackbar = useSnackbar();

  const submit = async (values) => {
    const { vendedor, motivo } = values;
    setSubmitting(true);

    await Api.put(
      "cancel-order",
      "attendance",
      {
        IdAtendimento: IdAtendimento.toString(),
        IdPessoaLoja: IdPessoaLoja.toString(),
        NomeUsuarioCancelamento: vendedor,
        MotivoCancelamento: "Outros",
        ObservacaoCancelamento: motivo,
      },
      true
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(`Cancelamento realizando com sucesso!`, {
            severity: "success",
          });
          handleClose(values);
        } else {
          snackbar.showMessage(
            `Ocorreu um erro ao realizar o cancelamento. Verifique os parâmetros informados.`,
            {
              severity: "error",
            }
          );
          setSubmitting(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setSubmitting(false);      });
  };
  const dataHoje = new Date().toLocaleDateString();

  const formik = useFormik({
    initialValues: {
      vendedor: "",
      motivo: "",
      dataCancelamento: dataHoje,
    },
    onSubmit: submit,
  });

  const { values, handleChange, handleSubmit, dirty, resetForm } = formik;

  const handleClose = (cancelReturn) => {
    resetForm();
    onClose(cancelReturn);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>
            <span>
              <Typography id="alert-dialog-title" variant="h3" component="h3">
                Cancelar Pedido
              </Typography>
            </span>
          </DialogTitle>
          <PerfectScrollbar>
            <DialogContent style={{ padding: "1rem 1.5rem 1.5rem" }}>
              <>
                <Grid container>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel required>Vendedor</FormLabel>
                      <TextField
                        name="vendedor"
                        required
                        fullWidth
                        disabled={submitting}
                        value={values.vendedor}
                        variant="outlined"
                        onChange={handleChange}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .toString()
                            .slice(0, 50);
                        }}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel required>Motivo do cancelamento</FormLabel>
                      <TextField
                        name="motivo"
                        multiline
                        required
                        rows={4}
                        fullWidth
                        disabled={submitting}
                        value={values.motivo}
                        variant="outlined"
                        onChange={handleChange}
                        inputProps={{ minLength: 15 }}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .toString()
                            .slice(0, 1000);
                        }}
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </>
              {submitting && (
                <div style={{ marginTop: "1rem" }}>
                  <span>Salvando cancelamento</span>
                  <LinearProgress />
                </div>
              )}
            </DialogContent>
          </PerfectScrollbar>
          <DialogActions>
            <Button component={Box} onClick={handleClose} disabled={submitting}>
              Cancelar
            </Button>

            <Button
              color="default"
              variant="contained"
              type="submit"
              disabled={
                submitting ||
                !dirty ||
                MaskAndValid.isNullOrEmpty(values.motivo) ||
                MaskAndValid.isNullOrEmpty(values.vendedor) ||
                values?.motivo?.length < 15
              }
            >
              Salvar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
